import type { ICustomControlProcedureDiagnosticReportReadProps } from '../interfaces/';
import { ProcedureDiagnosticReportReadButtons } from '../../../elements/carePathButtons/ProcedureDiagnosticReportReadButtons';
import { ProcessContainer } from '../../episodes/common';
import { OrthCV1RequestReadForOrthO } from '../OrthC/v1/OrthCV1RequestReadForOrthO';
import { OrthOV1DiagnosticReportRead } from './OrthOV1DiagnosticReportRead';
import { OrthOV1ProcedureRead } from './OrthOV1ProcedureRead';

export interface IOrthopticsV1ProcedureDiagnosticReportReadProps
    extends ICustomControlProcedureDiagnosticReportReadProps {
    isOrthOFol?: boolean;
}

export function OrthOV1ProcedureDiagnosticReportRead(props: IOrthopticsV1ProcedureDiagnosticReportReadProps) {
    return (
        <>
            <OrthOV1ProcedureRead
                isFirstItem={props.isFirstItem}
                isLastItem={false}
                isOrthOFol={props.isOrthOFol}
                itemState={props.itemState}
                procedure={props.procedure}
                process={props.process}
                request={props.request}
                serviceCode={props.serviceCode}
                supervision={props.supervision}
                updateItemState={props.updateItemState}
            />

            <OrthOV1DiagnosticReportRead
                diagnosticReport={props.diagnosticReport}
                isFirstItem={false}
                isLastItem={false}
                itemState={props.reportItemState}
                process={props.process}
                request={props.request}
                scrollToProcessItem={props.scrollToProcessItem}
                serviceCode={props.serviceCode}
                setHideCreateActions={props.setHideCreateActions}
                updateItemState={props.updateReportItemState}
            />

            <OrthCV1RequestReadForOrthO {...props} />

            <ProcessContainer isActiveActivity={props.itemState.initialIsOpen}>
                <ProcedureDiagnosticReportReadButtons
                    {...props}
                    hidePrintButton={true}
                />
            </ProcessContainer>
        </>
    );
}
